import React, { useState, useRef, useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import {MONTHS} from "../../utils";


export const SalesMonthFilter = ({ selectedMonth, onMonthChange, onFetch, onClear, isFiltered }) => {
  const [open, setOpen] = useState(false);
  const [viewYear, setViewYear] = useState(selectedMonth.getFullYear());
  const [cleared, setCleared] = useState(false);
  const ref = useRef(null);

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonthIndex = now.getMonth();

  
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (monthIndex) => {
    onMonthChange(new Date(viewYear, monthIndex, 1));
    setCleared(false);
    setOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setCleared(true);
    onClear();
  };

  const isDisabled = (monthIndex) => {
    return viewYear === currentYear && monthIndex > currentMonthIndex;
  };

  const label = cleared
    ? "----"
    : selectedMonth.toLocaleString("en-US", { month: "long", year: "numeric" });

  return (
    <div className="flex items-center gap-2">
      <div ref={ref} className="relative flex items-center">
        <input
          readOnly
          value={label}
          onClick={() => setOpen((prev) => !prev)}
          className="border border-primary-title rounded-md px-3 py-2 text-sm font-nexa cursor-pointer w-36 pr-7"
        />
        {isFiltered && (
          <button
            onClick={handleClear}
            className="absolute right-2 text-gray-400 hover:text-red-500 transition-all"
          >
            <X size={14} />
          </button>
        )}
        {open && (
          <div className="absolute top-full left-0 mt-1 bg-white rounded-md shadow-lg p-3 w-56" style={{ zIndex: 9999 }}>
            {/* Year navigation */}
            <div className="flex items-center justify-between mb-3">
              <button
                onClick={() => setViewYear((y) => y - 1)}
                className="p-1 hover:bg-gray-100 rounded"
              >
                <ChevronLeft size={16} />
              </button>
              <span className="text-sm font-bold text-primary-dark">{viewYear}</span>
              <button
                onClick={() => setViewYear((y) => y + 1)}
                disabled={viewYear >= currentYear}
                className="p-1 hover:bg-gray-100 rounded disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <ChevronRight size={16} />
              </button>
            </div>

            {/* Month grid — 3 columns */}
            <div className="grid grid-cols-3 gap-1">
              {MONTHS.map((month, i) => {
                const disabled = isDisabled(i);
                const isSelected =
                  !cleared && selectedMonth.getMonth() === i && selectedMonth.getFullYear() === viewYear;
                return !disabled ? (
                  <button
                    key={month}
                    onClick={() => handleSelect(i)}
                    className={`py-1.5 text-sm rounded-md transition-all ${
                      isSelected
                        ? "bg-primary-title text-white"
                        : "hover:bg-primary-light text-primary-dark"
                    }`}
                  >
                    {month}
                  </button>
                ) : null;
              })}
            </div>

            {/* Clear inside calendar */}
            <div className="mt-3 border-t border-gray-100 pt-2 flex justify-end">
              <button
                onClick={(e) => { handleClear(e); setOpen(false); }}
                className="text-xs text-blue-500 hover:text-blue-600 font-nexa"
              >
                Clear
              </button>
            </div>
          </div>
        )}
      </div>
      <button
        className="flex gap-2 bg-primary-title text-white px-3 py-2 rounded-md text-sm hover:bg-primary-dark transition-all"
        onClick={onFetch}
      >
        Fetch
      </button>
    </div>
  );
};
